import {Grid, Typography} from "@mui/material";
import portada_servicios from "../../../Recursos/portada_servicios.png";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Portada_SobreMi = () => {

    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container   alignItems={'flex-start'} size={{xs: 12, sm: 12, md: 10}} sx={{maxWidth: 1400, px: 3, py:sCell? 4:8, pb:12, }} >
                <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{color: '#223B59'}}>
                    <Grid container justifyContent={{ xs: 'center', md: 'flex-start' }} size={{xs: 12, sm: 12, md: 12}}>
                        <Typography component={'h1'} variant={"h1"} sx={{textAlign: sCell? 'center':'left', pr:sCell?0:8}}>
                            Espacio Compacto: expertos en mantenimiento locativo, arquitectura funcional y SST en Cali
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container  justifyContent={'flex-end'} size={{xs: 12, sm: 5, md: 5}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:sCell?4:0, textAlign: sCell? 'center':'left',}}>
                        <Typography component={"p"} variant={"body1"}>
                            Somos una firma especializada en gestión de mantenimiento, adecuaciones locativas y SST en obras, enfocada en resolver problemas reales de operación, seguridad y cumplimiento.
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )

}
export default Portada_SobreMi